import React, {
	Component
} from 'react';

import Footer from '../exercise/Footer';
import ImgPreview from '../components/imgPreview'


class Question extends Component {
	constructor(props) {
		super(props);
		this.state = {
			previewVisible:false
		};
	}

	componentDidMount() {
	}
	//图片预览
	handlePreviewImg=(status)=>{
		this.setState({previewVisible:status})
	}
	render() {
		let {previewVisible}=this.state
		const {num,children} = this.props;
		let originData = this.props.data;
		//题目检错页显示的是错的的答题答案
		if(this.props.errorAnswer) {
			originData.answer = this.props.errorAnswer
		} 

		let stem = JSON.parse(originData.stem)
		return(
			<div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><span className="math_text">{`${num + 1}、`}</span></div>}
                    <div className="exercise-con">
                        <span className="form-label">中文引导语：</span>
                        <div className="form-content">{stem.guide_text}</div>
                        <span className="form-label">引导语音频：</span>
                        <div className="form-content">
                           <audio  src={stem.guide_audio} controls="controls">您的浏览器不支持</audio>                         
                        </div>
                         <span className="form-label">单词：</span>
                        <div className="form-content">{stem.english_text}</div>
                        {
                        		stem.img&&
                        		<div>
                        			<span className="form-label">图片：</span>
                        			<div className="form-content">
                        		 	<img src={stem.img} onClick={()=>this.handlePreviewImg(true)}  width={120}  style={{maxHeight:70}}/>
                        			</div>
                        			<ImgPreview previewVisible={previewVisible} previewImage={stem.img} handlePreviewImg={this.handlePreviewImg}/>
                        		</div>
                        }
                    </div>

                </div>
                <div className="exercise-footer">
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                        </Footer>
                    </div>
                </div>
            </div>

		)
	}
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/wordReading/viewForView.js